module.exports = __webpack_public_path__ + "img/guilin.c06e35da.png";